import { Page, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  coversheet: {
    position: "absolute",
    justifyContent: "space-around",
    color: "white",
    fontSize: 30,
    marginBottom: 60,
  },
});

const Coversheet = (props) => {
  const { Deckblatt } = props;
  return (
    <Page size="A4" style={styles.coversheet}>
      {props.children}
    </Page>
  );
};

export default Coversheet;
